import { atom } from 'recoil';

export const isClientDocumentsFilterModalOpenAtom = atom<boolean>({
  key: 'isClientDocumentsFilterModalOpenState',
  default: false,
});
